import {Link} from 'react-router-dom'
import {observer} from 'mobx-react'
import UI from '../stores/UI'

const Navbar = () => {

  let seg1 = "span-9", seg2 = "span-1", seg3 = "span-1", seg4 = "span-1"

  if (UI.page === 1) {
    seg1 = "span-4", seg2 = "span-4", seg3 = "span-2", seg4 = "span-2"
  } else if (UI.page === 2) {
    seg1 = "span-2", seg2 = "span-2", seg3 = "span-4", seg4 = "span-4"
  } else if (UI.page === 3) {
    seg1 = "span-2", seg2 = "span-1", seg3 = "span-1", seg4 = "span-8"
  } else {
    seg1 = "span-9", seg2 = "span-1", seg3 = "span-1", seg4 = "span-1"
  }

  return (
    <nav className="padx2 h5" style={{
      zIndex: UI.showNav ? 100 : 0
    }}>

      <div className={`navlink`}>
        <Link to="/">Works by Madge Gill</Link>
      </div>
      <div className="line" style={{
        flexGrow: UI.page === 0 ? 20 : 1
      }}></div>
      <div className={`navlink txt-c`}>
        <Link to="/texts">Texts</Link>
      </div>
      <div className="line" style={{
        flexGrow: UI.page === 1 ? 20 : 1
      }}></div>
      <div className={`navlink txt-c`}>
        <Link to="/events">Events</Link>
      </div>
      <div className="line" style={{
        flexGrow: UI.page >= 2 ? 20 : 1
      }}></div>
      <div className={`navlink txt-r`}>
        <Link to="/information">Information</Link>
      </div>

    </nav>
  )
}

export default observer(Navbar)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Navbar.js